import React from 'react';

export default function Box({ iconClass }: { iconClass?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <path d="m485 192-45.7-64H344v64zm11 48H144v256h352zm-341-48h141v-64h-95.3zm21-112h288l80 112v352H96V192z" />
    </svg>
  )
}
